import { render, staticRenderFns } from "./SearchOldReceipt.vue?vue&type=template&id=3ac0f51f&scoped=true&"
import script from "./SearchOldReceipt.vue?vue&type=script&lang=js&"
export * from "./SearchOldReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0f51f",
  null
  
)

export default component.exports